import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import type {EmailAddress as EmailAddressFragment} from 'nutshell-graphql-types';

import {EmailCcSelection} from '../../header/email-cc-selection';
import {EmailToSelection} from '../../header/email-to-selection';

type Props = FieldProps & {
    emails: EmailAddressFragment[];
    onShowCC?: () => void;
};
export const RecipientsField: (...args: any) => any = ({emails, onShowCC, input, meta}: Props) => {
    const currentEmails = emails.filter((email: EmailAddressFragment) => !email.isFormer);
    const selectedCurrentEmails = (input.value || []).filter(
        (email: EmailAddressFragment) => !email.isFormer
    );

    if (input.name === 'ccAddresses') {
        return (
            <EmailCcSelection
                onChange={input.onChange}
                errorMessage={meta.submitFailed ? meta.error : ''}
                onBlur={() => input.onBlur()}
                onFocus={(e: any) => {
                    input.onFocus(e);
                }}
                selectedAddresses={input.value}
                availableAddresses={emails}
            />
        );
    }

    return (
        <EmailToSelection
            onChange={input.onChange}
            onShowCC={onShowCC}
            errorMessage={meta.submitFailed ? meta.error : ''}
            onBlur={() => input.onBlur()}
            // @ts-expect-error
            onFocus={(e: any) => {
                input.onFocus(e);
            }}
            selectedAddresses={selectedCurrentEmails}
            availableAddresses={currentEmails}
        />
    );
};
